import React from 'react';
import Trip from './Trip';

function TripCollection({ trips, setTrips, tripOrderId, refreshTripOrder, returnDate }) {
  const minTotalPrice = Math.min(...trips.map(trip => trip.total_price).filter(price => price !== null && price !== 0));
  console.log('TripCollection received trips:', trips);
  console.log('TripCollection received refreshTripOrder:', refreshTripOrder);

  if (!trips) {
    console.log('Trips is undefined or null');
    return <div className="trip-collection">Loading trips...</div>;
  }

  if (!Array.isArray(trips)) {
    console.log('Trips is not an array:', typeof trips);
    // Instead of returning an error, we'll create an empty array
    trips = [];
  }

  if (trips.length === 0) {
    console.log('Trips array is empty');
    return <div className="trip-collection">No trips available</div>;
  }

  console.log('Rendering', trips.length, 'trips');

  // Sort trips by position
  const sortedTrips = [...trips].sort((a, b) => a.position - b.position);

  return (
    <div className="trip-collection">
      {sortedTrips.map((trip, index) => {
        console.log('Rendering trip:', trip);
        return (
          <Trip
            key={trip.id || `trip-${index}`}
            trip={trip}
            setTrips={(updatedTrip) => {
              const newTrips = Array.isArray(trips) ? [...trips] : [];
              const updatedIndex = newTrips.findIndex(t => t.id === trip.id);
              if (updatedIndex !== -1) {
                newTrips[updatedIndex] = updatedTrip;
                setTrips(newTrips);
              }
            }}
            tripOrderId={tripOrderId}
            refreshTripOrder={refreshTripOrder}
            returnDate={returnDate}
            minTotalPrice={minTotalPrice}
          />
        );
      })}
      {console.log('refreshTripOrder passed to Trip:', refreshTripOrder)}
    </div>
  );
}

export default TripCollection;
